import { User } from '@uplift/types';
import { restClient } from '../client';


export type CheckProviderInviteLinkInput = {
  invite_token: string;
};

export type CheckProviderInviteLinkOutput = {
  error?: string;
  user?: User;
};

export const checkProviderInviteLink = (params: CheckProviderInviteLinkInput) => restClient.request<CheckProviderInviteLinkOutput>('/auth/check_provider_invite_link', {
  method: 'POST',
  data: params,
});
